import { render, staticRenderFns } from "./Redoc.vue?vue&type=template&id=385a7a41&lang=pug&"
import script from "./Redoc.vue?vue&type=script&lang=ts&"
export * from "./Redoc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports